import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import TabArrow from '@hellodarwin/icons/dist/icons/TabArrow';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import Loading from '../../../loading';
import Collapse from '../../Collapse';
import Typography from '../../typography';
import { SidebarBlockContainer, SidebarBlockHeader } from './styles';
const useSidebarBlocks = ({ blocks }) => {
    const theme = useTheme();
    return useMemo(() => {
        const fixedPanels = blocks
            .filter((block) => block.fixed)
            .map((block) => {
            const { id, isLoading, content, children } = block;
            return {
                id,
                content: (_jsxs(_Fragment, { children: [!!content && (_jsx(SidebarBlockContainer, { children: isLoading ? _jsx(Loading, {}) : content })), !!(children === null || children === void 0 ? void 0 : children.length) && (_jsx(_Fragment, { children: children.map((child) => (_jsx(SidebarBlockContainer, { children: child.isLoading ? _jsx(Loading, {}) : child.content }, child.id))) }))] })),
            };
        });
        const panels = blocks
            .filter((block) => !block.fixed)
            .map((block) => {
            const { isLoading, content, title, extra, actions, children, id } = block;
            const panel = {
                id,
                title: (_jsxs(SidebarBlockHeader, { children: [_jsx(Typography, { elementTheme: "subtitle2", children: title }), actions, extra] })),
                children: (_jsxs(_Fragment, { children: [!!content && (_jsx(SidebarBlockContainer, { children: isLoading ? _jsx(Loading, {}) : content })), !!(children === null || children === void 0 ? void 0 : children.length) && (_jsx(Collapse, { ghost: true, style: { overflow: 'hidden' }, defaultActiveKey: children
                                .filter((child) => !child.defaultClosed)
                                .map((child) => child.id), noPadding: true, styles: {
                                panelContainer: {
                                    padding: '8px',
                                },
                                panelContent: {
                                    paddingTop: 16,
                                },
                            }, expandIconPosition: "start", items: children.map((child) => ({
                                id: child.id,
                                title: (_jsxs(SidebarBlockHeader, { children: [_jsx(Typography, { elementTheme: "body2", children: child.title }), child.actions, child.extra] })),
                                children: (_jsx(SidebarBlockContainer, { children: isLoading ? _jsx(Loading, {}) : child.content })),
                            })), ExpandIcon: ({ isActive }) => (_jsx(TabArrow, { down: isActive, size: 12, color: theme.colors.grey_2 })) }))] })),
            };
            return panel;
        });
        const defaultActiveKeys = blocks
            .filter((itm) => !itm.defaultClosed && !itm.fixed)
            .map((itm) => itm.id);
        return { fixedPanels, panels, defaultActiveKeys };
    }, [blocks, theme.colors.grey_2]);
};
export default useSidebarBlocks;
